import React, { useEffect } from "react";

// Internal Imports
import { GRID } from "../../constants";
import { LazyLoad } from "../../commonComponents";

// Css Imports
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import LZLoader from "../../commonComponents/LZLoader";

// Component Dynamic Imports
const AgGridReact = LazyLoad(() =>
  import(/* webpackChunkName: "ag-grid-react" */ "ag-grid-react").then(
    module => ({
      default: module.AgGridReact,
    }),
  ),
);

// Destructuring
const { GRID_PAGE_NO_BACK_SWIPE } = GRID;

const AgGridWrapper = props => {
  const { onGridReady, rowData, ...otherProps } = props;
  // componentDidMount
  useEffect(() => {
    document.body.classList.toggle(GRID_PAGE_NO_BACK_SWIPE);
  }, []);

  // componentWillUnMount`
  useEffect(
    () => () => {
      document.body.classList.remove(GRID_PAGE_NO_BACK_SWIPE);
    },
    [],
  );

  return (
    <React.Suspense fallback={<LZLoader label="Please wait..." largeLabel />}>
      <AgGridReact
        reactNext
        onGridReady={params => {
          props.onGridReady(params);
        }}
        columnDefs={props.columnData}
        rowData={props.rowData}
        {...otherProps}
      />
    </React.Suspense>
  );
};

export default AgGridWrapper;
